/*
 * About Us「数字で見るミライラボ」の数字を、画面に入ったときに 0 からカウントアップする。
 * (MIK-1087、定例 2026-10-01)
 *
 * - HTML には最終値をそのまま書いておく。JS が動かない環境ではそれがそのまま見える
 * - 「視差効果を減らす」設定(prefers-reduced-motion)では動かさない
 * - 小数の桁数(1.5)と桁区切り(2,300)は元の書き方を保つ。2015 のような年は区切らない
 * - 数え上げ中は数字の幅を最終値の幅で固定し、単位とラベルを揺らさない
 * - 読み上げは最終値だけにする(途中の数字は aria-hidden の側で動かす)
 */
(function () {
  'use strict';

  var SELECTOR = '[data-countup]';
  var NUMBER = /^(\d{1,3}(?:,\d{3})+|\d+)(?:\.(\d+))?$/;

  function parse(text) {
    var m = NUMBER.exec(text.trim());
    if (!m) return null;
    return {
      value: parseFloat(m[1].replace(/,/g, '') + (m[2] ? '.' + m[2] : '')),
      decimals: m[2] ? m[2].length : 0,
      grouped: m[1].indexOf(',') !== -1
    };
  }

  function format(n, spec) {
    var fixed = n.toFixed(spec.decimals);
    if (!spec.grouped) return fixed;
    var parts = fixed.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
  }

  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  // 数字の読み書きだけを Node から検査する(.github/scripts/test_about_us_mik1087.rb)
  if (typeof module === 'object' && module.exports) {
    module.exports = { parse: parse, format: format };
  }
  if (typeof document === 'undefined') return;

  function animate(el, spec, finalText, duration) {
    var start = null;
    function frame(now) {
      if (start === null) start = now;
      var t = Math.min((now - start) / duration, 1);
      el.textContent = t < 1 ? format(spec.value * easeOutCubic(t), spec) : finalText;
      if (t < 1) {
        window.requestAnimationFrame(frame);
      } else {
        el.style.minWidth = '';
        el.removeAttribute('data-countup-state');
      }
    }
    window.requestAnimationFrame(frame);
  }

  function prepare(el) {
    if (el.hasAttribute('data-countup-state')) return null;
    var finalText = el.textContent.trim();
    var spec = parse(finalText);
    if (!spec) return null;

    // 読み上げ用に最終値を残し、動く側は支援技術から隠す
    var sr = document.createElement('span');
    sr.className = 'about-numbers--sr';
    sr.textContent = finalText;
    el.parentNode.insertBefore(sr, el);
    el.setAttribute('aria-hidden', 'true');

    el.style.minWidth = el.getBoundingClientRect().width + 'px';
    el.setAttribute('data-countup-state', 'pending');
    el.textContent = format(0, spec);
    return { spec: spec, finalText: finalText };
  }

  function init(root) {
    var scope = root || document;
    var els = scope.querySelectorAll(SELECTOR);
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          observer.unobserve(el);
          var job = el.__countup;
          if (!job) return;
          el.setAttribute('data-countup-state', 'running');
          animate(el, job.spec, job.finalText, job.duration);
        });
      },
      { threshold: 0.6 }
    );

    Array.prototype.forEach.call(els, function (el) {
      var job = prepare(el);
      if (!job) return;
      job.duration = parseFloat(el.getAttribute('data-countup-duration')) || 1600;
      el.__countup = job;
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // テーマエディタでセクションを描き直したとき
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
